<template>
  <div class="question">
    <div class="text">{{ titleText }}</div>
    <div class="answer-box">
      <div
        class="a"
        v-for="(item, index) in data.answerArr"
        :key="index"
        @click="choose(item, index)"
      >
        <img :src="'//cdn.original-fun.com/gugong/' + item.img + '.png'" />
        <div class="duigou" :class="{ 'show': index === selectedIndex }"></div>
      </div>
    </div>
    <div
      class="button"
      v-if="selectedIndex !== undefined && right === undefined"
      @click="submit"
    >
      {{ data.btnText }}
    </div>
    <div class="man">
      <div class="r">
        <img
          :src="'//cdn.original-fun.com/gugong/' + data.sideImg + '.png'"
        />
      </div>
    </div>

    <HeadTip
      :data="data"
      @jump="$emit('jump', right)"
      v-if="right !== undefined"
    ></HeadTip>
  </div>
</template>

<script>
//script
import Tools from '../../scripts/tools';
import { gsap } from 'gsap';

//Global
import Global from '../../scripts/Global';

//组件
import HeadTip from './headTip';

export default {
  props: ['data'],
  data() {
    return {
      titleText: this.data.qText,
      selectedIndex: undefined,
      selectedData: undefined,
      right: undefined,
    };
  },
  components: { HeadTip },
  created() {},
  computed: {},
  methods: {
    choose(item, index) {
      if (this.right === undefined) {
        this.selectedIndex = index;
        this.selectedData = item;
      }
    },
    submit() {
      if (this.selectedData !== undefined) {
        this.right = !!this.selectedData.right;
        if (this.right) {
          this.titleText = this.data.okText;
        } else {
          this.titleText = this.data.errText;
        }
        this.$emit('finish', this.right);
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.question {
  background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
  background-position: 0 90%;
  width: 7.5rem;
  height: 9rem;
  margin: 0 auto;
  background-repeat: no-repeat;
  position: relative;
  bottom: 0;
  background-size: contain;
  top: 50%;
  margin-top: -5rem;
  font-size: 12px;
  position: absolute;

  .text {
    width: 3.2rem;
    background: #ffffff54;
    margin: 2.2rem auto 0 auto;
    padding: 0.1rem 1rem 0.1rem 0.2rem;
    text-align: left;
    color: #6c5141;
    font-weight: bold;
  }

  .answer-box {
    width: 4rem;
    height: 4rem;

    margin: 0.5rem 1.35rem;
    .a {
      width: 1.9rem;
      height: 1.5rem;
      margin: 0.2rem 0 0.2rem 0;
      position: relative;
      float: left;
      img {
        width: 100%;
      }

      .duigou {
        display: none;
        background-image: url(//cdn.original-fun.com/gugong/对勾.png);
        background-position: center;
        background-size: contain;
        width: 1rem;
        height: 1rem;
        background-repeat: no-repeat;
        position: absolute;
        bottom: 0;
        right: 0;
        &.show {
          display: block;
        }
      }
    }
  }

  .button {
    background-image: url(//cdn.original-fun.com/gugong/答题未选中按钮.png);
    position: absolute;
    width: 4rem;
    height: 1rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    color: #fff;
    line-height: 1rem;
    margin-left: -2rem;
    margin-top: 0.1rem;
    left: 50%;
  }

  .man {
    position: absolute;
    width: 2rem;
    bottom: 0;
    right: 0.6rem;
    height: 10rem;
    .r {
      position: relative;
      width: 100%;
      height: 100%;
      text-align: center;
    }
    img {
      width: 2.4rem;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
